import { render, staticRenderFns } from "./SwitchForm.vue?vue&type=template&id=7a2aa1bf&"
import script from "./SwitchForm.vue?vue&type=script&lang=js&"
export * from "./SwitchForm.vue?vue&type=script&lang=js&"
import style0 from "./SwitchForm.vue?vue&type=style&index=0&id=7a2aa1bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports